import { PaletteOptions } from '@mui/material';

interface ExtendedPaletteOptions extends PaletteOptions {
    gradient?: {
        blue: string;
        multi: string;
    };
}

export const palette = {
    background: {
        default: '#FFFFFF',
        paper: '#FFFFFF',
    },

    primary: {
        main: '#0D49E1',
        light: '#EDF5FF',
        dark: '#051F61',
    },

    secondary: {
        main: '#3D4D5F',
        light: '#E4ECF7',
        dark: '#202C3A',
    },

    text: {
        primary: '#3D4D5F',
        secondary: '#7F8A9D',
        disabled: '#B2B8CF',
    },

    success: {
        main: '#01B40C',
        light: '#EBFAEC',
        dark: '#047E0C',
    },

    info: {
        main: '#2693FF',
        light: '#EEFAFF',
        dark: '#0964B3',
    },

    warning: {
        main: '#E68E0B',
        light: '#FFF6E8',
        dark: '#B67009',
    },

    error: {
        main: '#F21B1B',
        light: '#FEEDED',
        dark: '#AD0202',
    },

    rating: {
        main: '#F5C415',
        light: '#FFF5D1',
        dark: '#CFA307',
    },

    neutral: {
        main: '#8E8E8E',
        light: '#F4F4F4',
        dark: '#515357',
        contrastText: '#FFFFFF',
    },
    divider: '#F1F3F5',
    dividerDark: '#DDDDDD',
    border: '#C4C4C4',
    test: {
        main: '#785FDB',
    },
    gradient: {
        blue: 'linear-gradient(135deg, #0d49e1 0%, #168bf2 100%)',
        multi: 'conic-gradient(from 0deg, #f21b1b 0%, #e68e0b 25%, #f5c415 50%, #01b40c 75%, #047e0c 100%)',
    },
} satisfies ExtendedPaletteOptions;
